<template>
  <div>
    <StepsNavigation />

    <StepContainer v-if="!currentStep" :has-form="false" :has-stepper="false">
      <Landing />
    </StepContainer>

    <StepContainer v-if="currentStep === stepsSet.fleetDetails">
      <FleetDetails />
    </StepContainer>

    <StepContainer v-if="currentStep === stepsSet.tires">
      <Tires />
    </StepContainer>

    <StepContainer v-if="currentStep === stepsSet.fuel">
      <Fuel />
    </StepContainer>

    <StepContainer v-if="currentStep === stepsSet.maintenance">
      <Maintenance />
    </StepContainer>

    <StepContainer v-if="currentStep === stepsSet.roadCalls">
      <RoadCalls />
    </StepContainer>

    <StepContainer
      v-if="currentStep === stepsSet.review"
      :has-form="false"
      :has-icon="false"
    >
      <Review />
    </StepContainer>

    <StepContainer
      v-if="currentStep === stepsSet.summary"
      :has-form="false"
      :has-icon="false"
    >
      <Summary />
    </StepContainer>
  </div>
</template>

<script>
import {
  FleetDetails,
  Tires,
  Fuel,
  RoadCalls,
  Maintenance,
  Landing,
  Review,
  Summary,
} from './step-components';
import StepContainer from './step-elements/StepContainer.vue';
import StepsNavigation from './step-elements/StepsNavigation.vue';
import { mapGetters, mutation, store } from './store';

export default {
  name: 'ROICalculator',

  store,

  components: {
    Landing,
    StepsNavigation,
    FleetDetails,
    Tires,
    Fuel,
    Maintenance,
    RoadCalls,
    Review,
    Summary,
    StepContainer,
  },

  computed: {
    ...mapGetters(['currentStep']),

    /** @returns {StepsSet} */
    stepsSet() {
      return this.$store.state.roiCalculator.stepsSet;
    },
  },

  created() {
    this.$store.commit(mutation('SET_INITIAL_CALCULATION'));
  },
};

/**
 * @typedef {import('./store/state').StepsSet} StepsSet
 */
</script>
